import React, { FC, Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, FormControl, Grid, IconButton, Input } from '@material-ui/core';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircleOutline';

import { ClientDepartment } from 'api';
import { Alert } from 'components';

interface IProps {
  department: ClientDepartment;
  removeKey: string;
  confirmKey: string;
  canRemove: boolean;
  onRemove: (department: ClientDepartment) => void;
}

const RemoveDepartment: FC<IProps> = props => {
  const { department, canRemove, onRemove, removeKey, confirmKey } = props;
  const [deleteOpen, setDeleteOpen] = useState(false);
  const { t } = useTranslation();

  function toggleConfirm() {
    setDeleteOpen(!deleteOpen);
  }

  function renderAlert() {
    return (
      <Alert
        open={deleteOpen}
        onConfirm={() => {
          toggleConfirm();
          onRemove(department);
        }}
        onCancel={toggleConfirm}
        message={t(removeKey)}
        confirm={t(confirmKey)}
      />
    );
  }

  return (
    <Fragment>
      <Grid container alignItems="center">
        <Grid item xs>
          <Box mt={1}>
            <FormControl fullWidth>
              <Input disabled disableUnderline value={department.title} />
            </FormControl>
          </Box>
        </Grid>
        {canRemove && (
          <Grid item>
            <IconButton onClick={toggleConfirm}>
              <RemoveCircleIcon />
            </IconButton>
          </Grid>
        )}
      </Grid>
      {renderAlert()}
    </Fragment>
  );
};

export default RemoveDepartment;
